import { FC } from "react";
import { PacmanLoader } from "react-spinners";
import "./style.css";

interface Props {
  fullPage?: boolean;
  isLoading: boolean;
  size?: number;
  center?: boolean;
}

export const LoadingIndicator: FC<Props> = ({
  size = 20,
  isLoading = false,
  center = true,
}) => (
  <PacmanLoader
    color={"#084298"}
    loading={isLoading}
    size={size}
    cssOverride={{
      marginLeft: center ? "auto" : "0",
      marginRight: center ? "auto" : "0",
    }}
    aria-label="Loading Spinner"
    data-testid="loader"
  />
);
